export default __webpack_public_path__ + "static/rabbi-book-shelf-3a48be1338337d141835500af060ce24.jpg";